"use client";
import { useRegionStore } from "@/store/index";
import { Home, ShoppingBag } from "lucide-react";
import Link from "next/link";

const SuggestionLinks = () => {
  const { countryCode } = useRegionStore();

  return (
    <>
      {/* Action Buttons */}
      <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
        <Link
          href="/"
          className="bg-green-main font-inter inline-flex items-center gap-2 rounded-lg px-8 py-4 text-base font-semibold text-white transition-colors hover:bg-[#047a2e]"
        >
          <Home className="h-5 w-5" />
          Ir al inicio
        </Link>
        <Link
          href={`/${countryCode}/products`}
          className="border-green-main font-inter text-green-main hover:bg-green-main/10 inline-flex items-center gap-2 rounded-lg border-2 bg-transparent px-8 py-4 text-base font-semibold transition-colors"
        >
          <ShoppingBag className="h-5 w-5" />
          Ver productos
        </Link>
      </div>
      
      <div className="mt-12 border-t border-gray-200 pt-8">
        <p className="font-inter mb-4 text-sm font-semibold">
          Tal vez estabas buscando:
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          <Link
            href={`/${countryCode}/products`}
            className="bg-cream font-inter text-green-main rounded-full px-4 py-2 text-sm transition-colors hover:bg-[#FEC810]"
          >
            Productos
          </Link>
          <Link
            href={`/${countryCode}/login`}
            className="bg-cream font-inter text-green-main rounded-full px-4 py-2 text-sm transition-colors hover:bg-[#FEC810]"
          >
            Iniciar Sesión
          </Link>
        </div>
      </div>
    </>
  );
};

export default SuggestionLinks;
